import session from './session'

/**  需要在接口中传给后端*/
export const RESPONSE_TYPE = 'code'
export const CODE_KEY = 'code'
const TEST_URL = 'https://advnew.web.test.freefiremobile.com/' 
const PROD_URL = 'https://ff-advance.ff.garena.com/'
export const REDIRECT_URL = window.location.href.includes('https://advnew.web.test.freefiremobile.com')
  ? TEST_URL
  : PROD_URL

/**  查询参数 */
const urlQuery = (name: string): string | null => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  }
  return null
}
/** 更新url*/
const _updateUrl = (searchParams: string) => {
  const oldUrl = new URL(window.location.href)
  const newUrl = new URL(`${oldUrl.origin}${oldUrl.pathname}?${searchParams}`)
  const state = { update: newUrl.href }
  window.history.pushState(state, '', newUrl.href)
}
/** 删除query */
export const deleteQuery = (keys: string[]) => {
  const params = new URLSearchParams(window.location.search)
  keys.forEach((item) => {
    if (params.has(item)) {
      params.delete(item)
    }
  })
  _updateUrl(params.toString())
}
/** 设置 code */

/**  获取code*/
export const getCode = () => {
  return urlQuery('code')
}
/**  包装参数 */
const wrapParams = (params: { [x: string]: any }) => {
  const code = getCode()
    if (!code) return params
    session.setItem(CODE_KEY, code)
    params['code'] = code
    params['redirect_uri'] = REDIRECT_URL
    params['live_access_token']
}
